import './IconLink.css'

interface IconLinkParams {
    link: Link;
    imgSrc: string;
}

interface Link {
    url: string;
    title?: string;
}

function IconLink({ link, imgSrc }: IconLinkParams) {
    const { url, title } = link;
    return <>
        <div className="icon-container">
            <a href={url} target='_open'><img src={imgSrc} alt="link icon"/></a>
            { title ? <h4>{title}</h4> : null }
        </div>
    </>
}

export default IconLink;